import type { ReactNode } from 'react';
import { ShieldAlert } from 'lucide-react';
import { usePermission } from '@/hooks/usePermission';
import { Card, CardContent } from '@/components/ui/card';

/**
 * La historia clínica es reservada (Ley 576, art. 61): sin permiso clínico la
 * pantalla lo dice, en vez de quedarse vacía con errores de la base. La base
 * rechaza igual; esto es para que la persona entienda por qué.
 */
export function SoloEquipoClinico({ children }: { children: ReactNode }) {
  const puedeLeer = usePermission('clinical:read');
  if (puedeLeer) return <>{children}</>;
  return (
    <Card className="mx-auto mt-8 max-w-lg">
      <CardContent className="space-y-3 p-6 text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-100 text-sky-700">
          <ShieldAlert className="h-6 w-6" />
        </div>
        <h2 className="font-display text-xl font-bold">La historia clínica es del equipo clínico</h2>
        <p className="text-sm text-muted-foreground">
          Por ley es información reservada: la ven los veterinarios y la administración.
          Si necesitas acceso, pídelo a quien administra la clínica.
        </p>
      </CardContent>
    </Card>
  );
}
